import { ReactNode } from 'react';
import { FormApi } from 'final-form';
import { IApiResponse, ITransferBeneficiary } from 'utils/models';

export const FAB_BANK = { code: '300316', name: 'First Atlantic Bank' };

export type FormType = FormApi<IFormValues, Partial<IFormValues>>;

export const bulkDataConfig = {
  sourceAccount: 'Source Account:',
  Numberoftransactions: 'Number of transactions:',
  PrincipalAmount: 'Principal Amount:',
  transactionCharge: 'Transaction Charge:',
  totalAmount: 'Total Amount:',
  frequency: 'Frequency:',
  startDate: 'Special Date:',
};

export const bulkSortArray = [
  'Source Account:',
  'Number of transactions:',
  'Principal Amount:',
  'Transaction Charge:',
  'Total Amount:',
];

export const sortWithScheduleArrays = [
  'Source Account:',
  'Number of transactions:',
  'Principal Amount:',
  'Transaction Charge:',
  'Total Amount:',
  'Frequency:',
  'Special Date:',
];

export const types = [
  { name: 'DOMESTIC TRANSFER', key: 'domestic' },
  { name: 'INSTANT TRANSFER', key: 'instant' },
  { name: 'NON-INSTANT TRANSFER', key: 'noninstant' },
];

export enum TransactionType {
  LOCAL ='LOCAL',
  INSTANT_INTERBANK = 'INSTANT_INTERBANK',
  NON_INSTANT_INTERBANK = 'NON_INSTANT_INTERBANK',
}

export interface IExtraFields {
  destinationBankName: string;
  destinationBankCode: string;
  destinationAccountName: string;
  destinationIsExistingBen: boolean;
  beneficiaryId?: number;
  charge?: number;
}

export interface ITransfersState {
  transferBeneficiaries: ITransferBeneficiary[];
  types: typeof types;
  banks: IBank[];
  instantBanks?: IInstantBank[];
  bankBranch: any;
  isLookingUp?: boolean;
  extras: IExtraFields;
  lastLookedUpAccount: string;
  lastLookedUpBankCode: string;
}

export interface IFormValues {
  sourceAccount: string;
  scheduleTransfer?: boolean;
  frequency: string;
  startDate: string
  transferData: {
    beneficiaryName: string;
    beneficiaryBank: string;
    bankBranch: string;
    transactionAmount: number | string;
    transactionDescription: string;
    beneficiaryAccount: string;
    transactionType: string;
    charge: number | string;
    beneficiaryId: number | string;
  }[]
}

export interface IOtherLookupRes extends IApiResponse {
  beneficiaryId: number;
  name: string;
}

export interface ITransactionField {
  label: ReactNode;
  value: ReactNode;
}

export interface IBank {
  code: string;
  name: string;
  shortName?: string;
}

export interface ITransferResponse extends IApiResponse {
  transactionId: number;
}

export interface IAccountLookup {
  name: string;
  beneficiaryId?: number;
}

export interface ILocalLookupRes extends IApiResponse {
  accountName: string;
}

export interface IGetTransferBeneficiaries extends IApiResponse {
  beneficiaries: ITransferBeneficiary[];
}

export interface IGetBankInstitutions extends IApiResponse {
  banks: IBank[];
}

export interface IGetBank {
  BankSortCode: string;
  BankName: string;
  BankShortName: string;
}

export interface IGetBankBranch {
  BankSortCode: string;
  BranchSortCode: string;
  BranchName: string;
  BranchCode: string;
}

export type IBanksMappedList = { INSTANT: IBank[]; NON_INSTANT: IBank[] };

export interface IGetBanks extends IApiResponse {
  banks: IGetBank[];
}

export interface IGetBankBranches extends IApiResponse {
  banks: IGetBankBranch[];
}

export interface IGetInstitutions extends IApiResponse {
  banks: IInstantBank[];
}

export interface IInstantBank {
  code: string;
  name: string;
}

export interface ITransferCharge extends IApiResponse {
  charge: number;
}

export interface ICharge {
  charge: number;
}

export interface ITransferActions {
  handleSelectBank: (index?: number) => void;
  findBeneficiaryName: (index: number) => void;
  getTransactionCharge: (index: number) => void;
}

export interface IFormCommonFields {
  sourceAccount: string;
  amount: number | string;
  destinationAccountNo: string;
  narration: string;
  destinationBankCode: string;
}

export type BankTypeKeys = 'INSTANT' | 'NON_INSTANT';

export interface IBulkCommonFields extends IFormCommonFields, IExtraFields {
  currencyCode: string;
  saveBen: boolean;
  eLevyFee: string;
  transferType?: BankTypeKeys;
  totalAmount: number;
  transactionAmount: string | number;
}

export interface IBulkCardData
  extends Pick<
    IBulkCommonFields,
    | 'destinationAccountNo'
    | 'eLevyFee'
    | 'sourceAccount'
    | 'narration'
    | 'destinationAccountName'
    | 'transferType'
    | 'transactionAmount'
    | 'totalAmount'
  > {
  destinationBankName?: string;
  transactionCharge?: string | number;
}

export type IBulkStatusModalP = {
  open: boolean;
  status: 'success' | 'failure';
  content: React.ReactChild;
}

export interface IBulkTransferData {
  Amount: number | string;
  DestinationAccountNo: string;
  Narration: string;
  DestinationBankCode: string;
  DestinationAccountName: string;
  CurrencyCode: string;
  SaveBen: boolean;
}

export interface IBulkTransferBody {
  sourceAccount: string;
  sourceAccountType: string;
  passwordType: string;
  password: string;
  bulkTransferData: IBulkTransferData[] | string;
}

export type IHandleFieldsChange = () => void;

export interface IElevyState {
  charge: string,
  taxableAmount: string,
  eLevyId: string,
}

export interface IElevyResponse extends IApiResponse {
  charge: string,
  taxableAmount: string,
  eLevyId: string,
}
